module.exports = "/public/webpack/img/icon_help_categories_player_324e596f484481b317b40ba2b10962738f.png";